'use client'

import type { NavBadgeKey } from '@/lib/navigation'

/**
 * Live counts for nav entries that declare a `badge` (Explorer needs-review,
 * Help Desk open). The count endpoint is a nice-to-have (plan 01 section 9.2),
 * so the rail stays clean until it exists: no badge is shown for a missing key.
 */
export function useNavBadges(): Partial<Record<NavBadgeKey, number>> {
  return {}
}
